import useAPIQuery from '../../api/useAPIQuery';
import { JobPostingDetail, RecruitmentProcessCollection, StageDetail } from '../../types';

interface StageAggregateTitleProps {
  id?: StageDetail['id'];
  name: string;
  type?: StageDetail['type'];
  status?: RecruitmentProcessCollection['status'];
  jobPostingId: JobPostingDetail['id'];
}

const StageAggregateTitle: React.FC<StageAggregateTitleProps> = ({
  id,
  name,
  type,
  status,
  jobPostingId,
}) => {
  const jobPosting = useAPIQuery(`/job-postings/${jobPostingId}/`, {
    enabled: type === 'HIRED',
  });

  const recruitmentProcesses = useAPIQuery(
    [
      '/recruitment-processes/',
      {
        params: {
          stage_id: id,
          status,
          job_posting: !id ? jobPostingId : undefined,
        },
      },
    ],
    { enabled: Boolean(id || status || jobPostingId) }
  );

  return (
    <div data-testid="stage-aggregate-title">
      {name} (
      <>
        {recruitmentProcesses.data?.count}
        {type === 'HIRED' && <>/{jobPosting.data?.positions}</>}
      </>
      )
    </div>
  );
};

export default StageAggregateTitle;
